
export const criteria = [
  { type: "nonSms", value: false },
  { type: "nonPrinting", value: false },
  { type: "nonEhf", value: false },
  { type: "nonEmail", value: false },
];